import { render, staticRenderFns } from "./vnp-input-box.vue?vue&type=template&id=34b7084a&scoped=true&"
import script from "./vnp-input-box.vue?vue&type=script&lang=js&"
export * from "./vnp-input-box.vue?vue&type=script&lang=js&"
import style0 from "./vnp-input-box.vue?vue&type=style&index=0&id=34b7084a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b7084a",
  null
  
)

export default component.exports